import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, Subject, Subscription, timer, fromEvent } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { popupService } from 'app/services/popup.service';
import { SvcServices } from './svc.service';
import { isPlatformBrowser } from '@angular/common';
const THROTTLE = (1000 * 60 * 2);  // 2 minutes

@Injectable({
  providedIn: 'root'
})
export class ChatBotInactivityTimeOutService {

  private timeoutMinutes: number = 3; // how it should wait before the chat bot blinking gets triggered
  // timeoutMinutes = 0; // DO NOT DELIVER: for dev unit testing only

  private timerSubscription: Subscription;
  private timer: Observable<number>;
  //to know whether timer gets expired and the number of times timer it gets expired
  private _count: number = 1;
  public timeoutExpired: Subject<number> = new Subject<number>();
  public redirectionTimeoutExpired: Subject<number> = new Subject<number>();
  public waitingForActionTimer: Observable<number>;
  public waitingForActionTimerSubscription: Subscription;


  private _invokeNgaKeepALive: boolean = false;
  public get invokeNgaKeepALive(): boolean {
    return this._invokeNgaKeepALive;
  }
  public set invokeNgaKeepALive(value: boolean) {
    this._invokeNgaKeepALive = value;
    this.startTimer(); //start timer
  }



  constructor(private _svcService: SvcServices, @Inject(PLATFORM_ID) private platformId: String) {
    if (isPlatformBrowser(this.platformId)) {
      this.documentClickBinding = this.documentClickEvent.subscribe(() => this.resetChatBotTimer());
    }
  }


  public startTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    this.timer = timer(this.timeoutMinutes * 60 * 1000);
    this.timerSubscription = this.timer.subscribe(n => {
      this.timerComplete(n);
    });
  }


  public redirectionStartTimer() {
    if (this.waitingForActionTimerSubscription) {
      this.waitingForActionTimerSubscription.unsubscribe();
    }

    this.waitingForActionTimer = timer(60 * 1000);
    this.waitingForActionTimerSubscription = this.waitingForActionTimer.subscribe(t => {
      this.redirectionTimerComplete(t);
    })
  }

  public stopTimer() {
    this.timerSubscription.unsubscribe();
  }

  public redirectionStopTimer() {
    if (this.waitingForActionTimerSubscription) {
      this.waitingForActionTimerSubscription.unsubscribe();
    }
  }

  public resetTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    this.timer = timer(this.timeoutMinutes * 60 * 1000);
    this.timerSubscription = this.timer.subscribe(n => {
      this.timerComplete(n);
    });
  }

  public redirectionResetTimer() {
    if (this.waitingForActionTimerSubscription) {
      this.waitingForActionTimerSubscription.unsubscribe();
    }

    this.waitingForActionTimer = timer(60 * 1000);
    this.waitingForActionTimerSubscription = this.waitingForActionTimer.subscribe(t => {
      this.redirectionTimerComplete(t);
    })
  }

  private timerComplete(n: number) {
    if (isPlatformBrowser(this.platformId)) {
      this.timeoutExpired.next(++this._count);
    }
  }

  private redirectionTimerComplete(n: number) {
    this.redirectionTimeoutExpired.next(++this._count);
  }

    /**
   * Observable subscription that gets bound to the `document` to handle generic user
   * activity on the page, as dispatched by `documentClickEvent`.
   * Used for preventing the session from becoming `IDLE`.
   */
  private documentClickBinding: Subscription;

  /**
   * Observable placed on the `document` to listen for generic user clicks. Once the
   * app state is set to `ACTIVE`, the subscription `documentClickBinding` will be
   * attached to this and throttled to fire once every two minutes, based on the
   * `THROTTLE` constant. Throttling in this way reduces traffic between the UI and
   * Olympus.
   */
  private documentClickEvent = fromEvent(document, 'click').pipe(throttleTime(THROTTLE));


  /**
   * resets chat bot blinking timer due to user activity.
   */
  public resetChatBotTimer() {

    if (this.invokeNgaKeepALive && this._svcService.isFusionChannel()) {
      this.resetTimer();

    }
  }

}

